import React from 'react';
import PropTypes from 'prop-types';
import StagingArchivingProfileStore from 'stores/StagingArchivingProfileStore';
import ArchivingProfileStore from 'stores/ArchivingProfileStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import EditArchivingProfilePage from './EditArchivingProfilePage';
import AltContainer from 'alt-container';
import StagingArchivingProfileActions from 'actions/StagingArchivingProfileActions';
import ArchivingProfileActions from 'actions/ArchivingProfileActions';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import {unsavedMessage} from 'utils/const';
import {getQueryParam} from 'utils/getQueryParam';

const byId = id => o => o.id === id;

export default class EditArchivingProfilePageContainer extends React.PureComponent {
  componentDidMount() {
    ArchivingProfileActions.fetchArchivingProfiles();
    this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }

  routerWillLeave = () => {
    const idParam = this.props.params.archivingProfileId;
    const id = idParam ? parseInt(idParam) : null;
    const {archivingProfiles} = ArchivingProfileStore.getState();
    const {archivingProfiles: stagingArchivingProfiles} = StagingArchivingProfileStore.getState();
    const profile = archivingProfiles.find(byId(id));
    const stagingProfile = stagingArchivingProfiles.find(byId(id));

    return stagingProfile && !stagingProfile.equals(profile) ? unsavedMessage : undefined;
  };

  render() {
    const idParam = this.props.params.archivingProfileId;
    const id = idParam ? parseInt(idParam) : null;
    return (
      <AltContainer
        stores={{
          ArchivingProfileStore,
          StagingArchivingProfileStore,
          DepartmentFormStore,
        }}
        actions={{
          DepartmentActions,
          DepartmentFormActions,
          StagingArchivingProfileActions,
          ArchivingProfileActions,
        }}>
        <EditArchivingProfilePage
          hasDepartmentContext={!!this.props.params.departmentId}
          departmentId={this.props.params.departmentId}
          addToDepartment={getQueryParam(this.props.location, 'addToDepartment')}
          id={id}
        />
      </AltContainer>
    );
  }
}
EditArchivingProfilePageContainer.contextTypes = {
  router: PropTypes.object,
};
